import type { useToast } from "@unreserved/hooks";


export async function handleHttpError(
    error: Error & { response?: Response },
    errorTitle?: string,
    toast?: ReturnType<typeof useToast>['toast']
): Promise<void> {
    const httpResponse = error.response;

    if (!httpResponse) {
        const errorMessage = error.message || "An unknown error occurred";
        toast?.error(errorTitle ?? "", { description: errorMessage });
        return;
    }
    try {
        const data = (await httpResponse!.json()) as { message?: string };
        const errorMessage = data?.message || "An unknown error occurred";
        toast?.error(errorTitle ?? "", { description: errorMessage });
    } catch {
        const errorMessage = "An unknown error occurred";
        toast?.error(errorTitle ?? "", { description: errorMessage });
    }
}


